import { buildHeaders } from "./apiConfig";
import { FETCH_AV_SYNC_STATUS_URL } from "../constants";

export const VIDEO_TRANSLATED_STATUS = "VIDEO_TRANSLATED";

export async function fetchAvSyncStatus(jobId, userEmail = "") {
  if (!FETCH_AV_SYNC_STATUS_URL) {
    throw new Error(
      "Sync status API URL not configured. " +
        "Set REACT_APP_FETCH_AV_SYNC_STATUS_URL in your .env file."
    );
  }
  if (!jobId) {
    throw new Error("jobId is required to check AV sync status.");
  }

  const url = FETCH_AV_SYNC_STATUS_URL.replace(/\/$/, "");
  const payload = JSON.stringify({ job_id: jobId, user_email: userEmail });

  // eslint-disable-next-line no-console
  console.log(`[syncStatusService] Polling — jobId: ${jobId}, user: ${userEmail}`);

  let response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: buildHeaders(),
      body: payload,
    });
  } catch (networkErr) {
    throw new Error("Network error while checking sync status. Please check your connection.");
  }

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    const detail = json.error || json.message || `HTTP ${response.status}`;
    // eslint-disable-next-line no-console
    console.error(`[syncStatusService] ❌ ${response.status} — ${detail}`);
    throw new Error(detail);
  }

  // Handles both array-of-objects and plain-object shapes from Lambda.
  let languageStatuses = [];

  if (
    Array.isArray(json.jobs) &&
    json.jobs.length > 0 &&
    Array.isArray(json.jobs[0].language_statuses)
  ) {
    // Shape: { jobs: [{ language_statuses: [{ Language, sync_status }, …] }] }
    // Normalise capital-L "Language" → lowercase "language" for consistency
    languageStatuses = json.jobs[0].language_statuses.map((entry) => ({
      ...entry,
      language: entry.Language || entry.language,
    }));
  } else if (Array.isArray(json.languages)) {
    // Shape: { languages: [{ language, sync_status }, …] }
    languageStatuses = json.languages;
  } else if (json.statuses && Array.isArray(json.statuses)) {
    // Shape: { statuses: [{ language, sync_status }, …] }
    languageStatuses = json.statuses;
  } else if (json.status && typeof json.status === "object") {
    // Shape: { status: { German: "VIDEO_TRANSLATED", … } }
    languageStatuses = Object.entries(json.status).map(([language, sync_status]) => ({
      language,
      sync_status,
    }));
  }

  const allTranslated =
    languageStatuses.length > 0 &&
    languageStatuses.every((entry) => entry.sync_status === VIDEO_TRANSLATED_STATUS);

  // eslint-disable-next-line no-console
  console.log(
    `[syncStatusService] Status response — allTranslated: ${allTranslated},`,
    languageStatuses
  );

  return { allTranslated, languageStatuses, raw: json };
}
